import { cva } from 'class-variance-authority';

/**
 * Styles for ForgotEmailContainer component
 */
export const forgotEmailContainerStyles = cva(
  [
    'w-full',
  ],
  {
    variants: {
      screen: {
        personalInfo: ['max-w-full'], // Allow card to control its own width
        mfaSelection: ['max-w-full', 'md:max-w-[396px]', 'lg:max-w-[476px]', 'mx-auto', 'mt-8', 'md:mt-12', 'lg:mt-16', 'mb-8', 'md:mb-12', 'lg:mb-16'],
        mfaCode: ['max-w-full', 'md:max-w-[396px]', 'lg:max-w-[476px]', 'mx-auto', 'mt-8', 'md:mt-12', 'lg:mt-16', 'mb-8', 'md:mb-12', 'lg:mb-16'],
      },
    },
    defaultVariants: {},
  }
);
